import { BaseComponent } from './baseComponent';

export class Tabs extends BaseComponent {
    private titles: NodeListOf<HTMLElement>;

    // no options for js yet...
    constructor(container: HTMLElement, options: Record<string, any>) {
        super(container, options);

        this.titles = this.container.querySelectorAll('.tab-title');
        this.titles.forEach(title => {
            title.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.handleChange(title)
            });
            title.addEventListener('keydown', this.handleKeydown.bind(this));
        });

        this.onLoad();
    }

    handleKeydown(event: KeyboardEvent) {
        const target = event.currentTarget;
        if (!(target instanceof Element)) return;
        const first = this.titles[0];
        const last = this.titles[this.titles.length - 1];
        let title;

        switch (event.key) {
            case 'ArrowLeft':
                title = (target.closest('li').previousElementSibling)
                    ? target.closest('li').previousElementSibling.querySelector('a')
                    : last;
                break;

            case 'ArrowRight':
                title = (target.closest('li').nextElementSibling)
                    ? target.closest('li').nextElementSibling.querySelector('a')
                    : first;
                break;

            case 'Home':
                title = first;
                break;

            case 'End':
                title = last;
                break;
        }
        if (title) this.handleChange(title);
    }

    handleChange(title: HTMLElement) {
        // timeout needed for some browsers
        setTimeout(() => {
            title.focus();
        }, 10)

        if (title.closest('li').classList.contains('is-active')) return;

        this.open(title.dataset.componentId);
    }

    open(componentId: string) {
        const prevActiveTitle = this.container.querySelector('.tabs .is-active a');
        const prevActiveContent = this.container.querySelector('.tab-content.is-active');
        const title = this.container.querySelector(`.tab-title[data-component-id="${componentId}"]`)
        const content = this.container.querySelector(`.tab-content[data-component-id="${componentId}"]`)

        prevActiveTitle.closest('li').classList.remove('is-active');
        prevActiveTitle.setAttribute('aria-selected', 'false');
        prevActiveTitle.setAttribute('tabindex', '-1');

        prevActiveContent.classList.remove('is-active');
        prevActiveContent.setAttribute('inert', 'true');

        title.closest('li').classList.add('is-active');
        title.setAttribute('aria-selected', 'true');
        title.setAttribute('tabindex', '0');

        content.classList.add('is-active');
        content.removeAttribute('inert');

        this.afterOpen(title.id);
    }

    public getDefaultOptions(options: Record<string, any> = {}) {
        const defaultOptions = {};
        return {
            ...super.getDefaultOptions(),
            ...defaultOptions,
            ...options,
        };
    }
}
